import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import API_URL from '../api';
import { postAuthDestination } from '../utils/redirect';
import brandLockup from '../assets/images/company-name.jpg';

const COLLEGES = [
  'IIT Bombay', 'IIT Delhi', 'IIT Madras', 'IIT Kharagpur', 'IIT Kanpur',
  'IIT Roorkee', 'IIT Guwahati', 'IIT Hyderabad', 'IIT Bhubaneswar',
  'IIT Gandhinagar', 'IIT Jodhpur', 'IIT Mandi', 'IIT Patna', 'IIT Ropar',
  'IIT BHU Varanasi', 'IIT Indore', 'IIT Tirupati', 'IIT Palakkad',
  'IIT Dharwad', 'IIT Bhilai', 'IIT Jammu', 'IIT Goa', 'IIT (ISM) Dhanbad',
  'NIT Trichy', 'NIT Surathkal', 'NIT Warangal', 'NIT Rourkela', 'NIT Calicut',
  'MNNIT Allahabad', 'MNIT Jaipur', 'MANIT Bhopal', 'NIT Durgapur',
  'NIT Kurukshetra', 'NIT Hamirpur', 'NIT Jalandhar', 'NIT Agartala',
  'NIT Patna', 'NIT Raipur', 'NIT Silchar', 'NIT Srinagar',
  'VNIT Nagpur', 'SVNIT Surat', 'NIT Delhi', 'NIT Jamshedpur',
  'DTU', 'NSUT',
];

const YEARS = [
  { value: '1', label: '1st Year (B.Tech)' },
  { value: '2', label: '2nd Year (B.Tech)' },
  { value: '3', label: '3rd Year (B.Tech)' },
  { value: '4', label: '4th Year (B.Tech)' },
  { value: '5', label: '5th Year (Dual/Integrated)' },
  { value: '6', label: 'M.Tech / M.S. 1st Year' },
  { value: '7', label: 'M.Tech / M.S. 2nd Year' },
  { value: '8', label: 'PhD Scholar' },
  { value: '9', label: 'MBA 1st Year' },
  { value: '10', label: 'MBA 2nd Year' },
];

function CompleteStudentProfile() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [form, setForm] = useState({ college: '', year: '', department: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!state?.id_token) return <Navigate to="/login" replace />;

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/auth/google/student/complete`, {
        id_token: state.id_token,
        college: form.college,
        year: form.year,
        department: form.department,
      });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      // `state.next` is the job (or other page) the candidate was on before
      // they were asked to sign in. Sign-up finishes by putting them back.
      navigate(postAuthDestination('student', state.next), { replace: true });
    } catch (err) {
      const msg = err.response?.data?.error || 'Something went wrong. Please try again.';
      const existingRole = err.response?.data?.existing_role;
      if (existingRole === 'recruiter') {
        setError(msg + ' You will be redirected to the login page.');
        setTimeout(() => navigate('/login?role=recruiter', { replace: true }), 2500);
      } else {
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" style={{ padding: '40px 24px' }}>
      <img src={brandLockup} alt="HyrSkill" className="auth-logo-img" />

      <div className="auth-card" style={{ maxWidth: 480 }}>
        {state.picture && (
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <img
              src={state.picture}
              alt={state.name}
              style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover' }}
            />
          </div>
        )}
        <h1 style={{ textAlign: 'center' }}>Almost there, {state.name?.split(' ')[0]}!</h1>
        <p className="auth-sub" style={{ textAlign: 'center' }}>
          Tell us a bit about your studies so recruiters can find you.
        </p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>College *</label>
            <select value={form.college} onChange={e => set('college', e.target.value)} required>
              <option value="">Select your college</option>
              <optgroup label="IITs">
                {COLLEGES.filter(c => c.startsWith('IIT')).map(c => <option key={c} value={c}>{c}</option>)}
              </optgroup>
              <optgroup label="NITs">
                {COLLEGES.filter(c => !c.startsWith('IIT')).map(c => <option key={c} value={c}>{c}</option>)}
              </optgroup>
            </select>
          </div>

          <div className="grid grid-2" style={{ gap: 14 }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Year *</label>
              <select value={form.year} onChange={e => set('year', e.target.value)} required>
                <option value="">Select year</option>
                {YEARS.map(y => <option key={y.value} value={y.value}>{y.label}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>Department *</label>
              <input
                type="text"
                value={form.department}
                onChange={e => set('department', e.target.value)}
                placeholder="e.g. Computer Science"
                required
              />
            </div>
          </div>

          <button type="submit" className="btn btn-full" style={{ marginTop: 22 }} disabled={loading}>
            {loading
              ? <><span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} /> Creating account…</>
              : 'Complete Sign Up'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CompleteStudentProfile;
